import { commentItems } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观众热评</h2>
          <p className="text-sm text-foreground-500">来看看其他观众怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}